import { z } from 'zod';

export const CommitmentPropsSchema = z.object({
  external_id: z.string().optional(),
  name: z.string().min(1, 'Name is required'),
  status: z.string().min(1, 'Status is required'),
  commitment_amount: z.number().positive(),
});

export type CommitmentProps = z.infer<typeof CommitmentPropsSchema>;
